import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <header>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-background-50 shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 group"
            >
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-lg font-bold">
                <i className="ri-book-read-line"></i>
              </span>
              <span className="text-xl font-bold text-foreground-900 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                爱漫画
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    location.pathname === link.to
                      ? 'text-primary-500'
                      : 'text-foreground-700 hover:text-primary-500'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            <div className="hidden md:flex items-center gap-3">
              <Link
                to="/category"
                className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-line mr-1.5"></i>找漫画
              </Link>
            </div>

            <button
              onClick={() => setIsMobileOpen(!isMobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {isMobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200">
            <div className="px-4 py-4 flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors duration-200 whitespace-nowrap ${
                    location.pathname === link.to
                      ? 'bg-primary-100 text-primary-500'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/category"
                className="mt-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium text-center hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-line mr-1.5"></i>找漫画
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}